import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { BaseResource } from '../core/resourceStoreTypes';

export type JobStatusProps = BaseResource & {
  datasetId?: string;
  type?: string;
};

export type CreateJobStatusPayload = JobStatusProps & {
  datasetId: string;
  type: string;
};

export type DeleteJobStatusPayload = Pick<JobStatusProps, 'id'>;

export type JobStatusMeta = Meta<JobStatusProps> & {
  attemptsLeft?: number;
};

const createJobStatusPayloadCreator = getPayloadCreator<CreateJobStatusPayload, JobStatusProps, JobStatusMeta>();
const jobStatusPayloadCreator = getPayloadCreator<JobStatusProps, JobStatusProps, JobStatusMeta>();
const deleteJobStatusPayloadCreator = getPayloadCreator<DeleteJobStatusPayload, JobStatusProps, JobStatusMeta>();
const deleteJobStatusSuccessPayloadCreator = getPayloadCreator<JobStatusProps | null, JobStatusProps, JobStatusMeta>();
const jobStatusFailurePayloadCreator = getFailurePayloadCreator<unknown, JobStatusMeta>();

export const createJobStatus = createAction('CREATE_JOB_STATUS', createJobStatusPayloadCreator);
export const createJobStatusSuccess = createAction('CREATE_JOB_STATUS_SUCCESS', jobStatusPayloadCreator);
export const createJobStatusFailure = createAction('CREATE_JOB_STATUS_FAILURE', jobStatusFailurePayloadCreator);

export const deleteJobStatus = createAction('DELETE_JOB_STATUS', deleteJobStatusPayloadCreator);
export const deleteJobStatusSuccess = createAction('DELETE_JOB_STATUS_SUCCESS', deleteJobStatusSuccessPayloadCreator);
export const deleteJobStatusFailure = createAction('DELETE_JOB_STATUS_FAILURE', jobStatusFailurePayloadCreator);
